import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient/ata/documentos-ata/processo-digital/DocumentoProcessoDigitalApiClient'
import { DownloadFile } from '@/core/utils'
import AssinarEletronicamenteLoteInput from '@/core/apiclient/processo-digital/models/AssinarEletronicamenteDocAtaLoteInput'
import AssinarEletronicamenteDocAtaLoteInput from '@/core/apiclient/processo-digital/models/AssinarEletronicamenteDocAtaLoteInput'

export default {
	async [actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.VISUALIZAR_PROCESSO_DIGITAL](context, idAta) {
		const { data } = await api.buscarProcessoDigitalUrl(idAta)
		return data
	},
	async [actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.JUNTAR_LOTE_DOCUMENTOS](context, payload) {
		const { data } = await api.juntarLoteDocumentosProcessoDigital(payload)
		return data
	},
	async [actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.BAIXAR_PARA_IMPRESSAO](context, idDocumento) {
		const response = await api.baixarDocumentoProcessoDigital(idDocumento)
		DownloadFile.downloadArrayBufferPdf(response.data, response.headers.filename)
	},
	async [actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.ASSINAR_ELETRONICAMENTE](context, idDocumento) {
		return await api.assinarEletronicamenteDocumentoProcessoDigital(idDocumento)
	},
	async [actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.ASSINAR_DIGITALMENTE](context, idDocumento) {
		return await api.assinarDigitalmenteDocumentoProcessoDigital(idDocumento)
	},
	async [actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.ASSINAR_ELETRONICAMENTE_LOTE](
		context,
		{ idAta, idsDocumentosAta },
	) {
		return api.assinarEletronicamenteLoteDocumentoProcessoDigital(
			idAta,
			new AssinarEletronicamenteDocAtaLoteInput(idAta, idsDocumentosAta),
		)
	},

	async [actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.VALIDAR_DOCUMENTO_ASSINADO](context, idDocumento) {
		const { data } = await api.validarSeDocumentoAtaFoiAssinadoNoProcessoDigital(idDocumento)
		return data
	},
	async [actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.BUSCAR_DOCUMENTO_POR_ID](context, idDocumento) {
		const { data } = await api.buscarPorId(idDocumento)
		return data
	},

	async [actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.CANCELAR_DOCUMENTO](context, payload) {
		return api.cancelarDocumentoProcessoDigital(payload)
	},
}
